package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import com.example.mystybag.sharedmodels.project.responseModels.BagCategoryLists
import kotlinx.serialization.Serializable

@Serializable
data class ReservationItem(
    val id: Long? = null,
    val bagId: Long? = null,
    val status: Int? = null, // 0=RESERVED, 1=PAID, 3=RECEIVED, 4=PAID_TO_MERCHANT
    val amount: Double? = null,
    val currency: String? = null,
    val locationId: Long? = null,
    val userFirstName: String? = null,
    val userLastName: String? = null,
    val bagName: String? = null,
    val bagsCount: Int? = null,
    val dateTimeReserved: String? = null, // date_time_reserved - дата на резервация/транзакция
    val settlementDate: String? = null // settlement_date - дата на изплащане (null = очаква изплащане)
)

@Serializable
data class PayoutItem(
    val id: Long? = null,
    val amount: Double? = null,
    val status: String? = null, // "pending", "paid", "expected", etc.
    val createdAt: String? = null
)

@Serializable
data class GetMerchantDashboardResponseModel(
    val bags: BagCategoryLists? = null,
    val locations: List<MerchantLocationResponseModel> = emptyList(),
    val companyPhoneNumber: String? = null,
    val companyDialCode: String? = null,
    val registeredCompanyStreet: String? = null,
    val registeredCompanyCityId: Long? = null,
    val registeredCompanyCityName: String? = null,
    val reservations: List<ReservationItem>? = null,
    val payouts: List<PayoutItem>? = null
) : BaseResponseModel()

